import { commonjsGlobal as T } from "./index61.js";
import { __exports as g } from "./index82.js";
import S from "react";
import "./index77.js";
import "./index145.js";
import { __exports as C } from "./index81.js";
import { __exports as M } from "./index147.js";
var A = T && T.__importDefault || function(a) {
  return a && a.__esModule ? a : { default: a };
};
Object.defineProperty(g, "__esModule", { value: !0 });
g.default = R;
var y = S, O = A(C), c = M, j = {
  cloneElement: y.cloneElement,
  createElement: y.createElement,
  isValidElement: y.isValidElement
};
function R(a, r) {
  var s, _, m, v, n;
  r === void 0 && (r = {});
  for (var l = [], d = typeof r.replace == "function", o = (s = r.transform) !== null && s !== void 0 ? s : c.returnFirstArg, h = (_ = r.library) !== null && _ !== void 0 ? _ : j, k = h.cloneElement, V = h.createElement, P = h.isValidElement, b = a.length, e = 0; e < b; e++) {
    var t = a[e];
    if (d) {
      var f = (m = r.replace) === null || m === void 0 ? void 0 : m.call(r, t, e);
      if (P(f)) {
        b > 1 && (f = k(f, {
          key: (v = f.key) !== null && v !== void 0 ? v : e
        })), l.push(o(f, t, e));
        continue;
      }
    }
    if (t.type === "text") {
      var E = !t.data.trim().length;
      if (E && t.parent && !(0, c.canTextBeChildOfNode)(t.parent) || r.trim && E)
        continue;
      l.push(o(t.data, t, e));
      continue;
    }
    var i = t, u = {};
    B(i) ? ((0, c.setStyleProp)(i.attribs.style, i.attribs), u = i.attribs) : i.attribs && (u = (0, O.default)(i.attribs, i.name));
    var p = void 0;
    switch (t.type) {
      case "script":
      case "style":
        t.children[0] && (u.dangerouslySetInnerHTML = {
          __html: t.children[0].data
        });
        break;
      case "tag":
        t.name === "textarea" && t.children[0] ? u.defaultValue = t.children[0].data : !((n = t.children) === null || n === void 0) && n.length && (p = R(t.children, r));
        break;
      default:
        continue;
    }
    b > 1 && (u.key = e), l.push(o(V(t.name, u, p), t, e));
  }
  return l.length === 1 ? l[0] : l;
}
function B(a) {
  return c.PRESERVE_CUSTOM_ATTRIBUTES && a.type === "tag" && (0, c.isCustomComponent)(a.name, a.attribs);
}
